import { electroneApi } from "./electron-route";

const TITLE_BAR = `${electroneApi}/title-bar`;

const electronProfileRoute = {
  titleBar: TITLE_BAR
};

export default electronProfileRoute;
